<template>
    <section  class="pda-default">
        <div class="t-headline5 mgt-3">
            {{ $t('1912') }}
            <!-- 프로필 이미지 관리 -->
        </div>
        <div class="t-body3 mgt-6 t-color-content1">
            {{ $t('1913') }}
            <!-- 프로필로 사용할 이미지를 설정하세요. -->
        </div>
    
        <div class="mgt-47">
            <div class="profile-wrap" v-if="profileData">
                <img :src="profileData.file.resourceUri ? profileData.file.resourceUri : require('@/images/thumnail.png')" alt=""
                    v-if="!cropperVisible"
                    @click="showFileChooser()"
                    class="w-full"
                >
                <vue-cropper
                    ref="cropper"
                    :src="cropImg"
                    alt="Source Image"
                    :cropmove="cropImage"
                    :autoCropArea="1"
                    v-if="cropperVisible"
                    class="cropper"
                >
                </vue-cropper>
            </div>
            <div class="profile-wrap" v-else >
                <!-- <img :src="require('@/images/thumnail.png')" alt=""
                    v-if="!cropperVisible"
                    @click="showFileChooser()"
                    class="w-full"
                > -->
                <div 
                    v-if="!cropperVisible"
                    @click="showFileChooser()"
                    style="height:35vh;widht:70%;background: #f3f1f1;padding-top: 30%;text-align: center;"
                > 
                {{ $t('273') }}
                </div>
                 <vue-cropper
                    ref="cropper"
                    :src="cropImg"
                    alt="Source Image"
                    :cropmove="cropImage"
                    :autoCropArea="1"
                    v-if="cropperVisible"
                    class="cropper"
                >
                </vue-cropper>
            </div>
            <input
                ref="input"
                type="file"
                name="image"
                accept="image/*"
                @change="setImage"
                class="d-none"
            />

            <div class="mgt-60">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="saveImage()">
                    {{$t('281')}}
                    <!-- 저장하기 -->
                </button>
            </div>

        </div>
    </section>
    
</template>

<script>
/**
 * 멤버십 - 프로필 이미지 변경 컴포넌트(membership - change profile image component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from '@/api/httpService.js'
import memberApi from '@/api/memberApi.js'

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { log } from 'util';

export default {
    components: {
        VueCropper
    },
    data() {
        return {
            profileData : null,
            cropImg: '',
            cropperVisible: false,
        }
    },
    mounted() {
        this.fatchData()
    },

    methods: {
        // 프로필 정보 가져오기(get profile information)
        fatchData() {
            this.cropImg = ''
            this.cropperVisible = false
            
            memberApi.getProileImage().then((response)=>{
                this.profileData = response.data.data
                console.log('profileData', this.profileData);
                
            })
        },

        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },

        showFileChooser() {
            this.$refs.input.click();
        },

        setImage(e) {
            this.cropperVisible = true
            const file = e.target.files[0];
            if (file.type.indexOf('image/') === -1) {
                console.log('Please select an image file');
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                this.imgSrc = event.target.result;
                // rebuild cropperjs with the updated source
                this.$refs.cropper.replace(event.target.result);
                };
                reader.readAsDataURL(file);
            } else {
                console.log('Sorry, FileReader API not supported');
            }
        },
            
        // 이미지 업로드 및 프로필 저장
        saveImage() {
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            // let canvasData = this.elemCanvas.toDataURL("image/png");
            let blob = this.dataURItoBlob(this.cropImg);
            //console.log('this.cropImg',this.cropImg);
            //console.log('blob',blob);

            let formData = new FormData()
            formData.append('file', blob, 'profile.png')

            //console.log('formData',formData)
            //return
            
            httpService.upload(formData).then((response) => {
                
                console.log('SUCCESS!!', response.data.data[0].name);
                let params = {
                    file: response.data.data[0],
                    backgroundColor: '',
                    defaultColor: '',
                    pattenColor: '',
                    pattenValue: [],
                }
                console.log('params', params);
                
                memberApi.uploadProileImage(params).then((response)=>{
                    // console.log(response);
                    // this.$forceUpdate()
                    // console.log('forceUpdate');
                    this.fatchData()
                    this.$snackOpen({
                        contents: 'Todo-프로필 이미지가 업데이트 되었습니다.',
                        btnDisplayYN: false,
                        btnDisplay: ''
                    }).then(() => {})
                    
                })
                
            })
            .catch((err) => {
                console.log('FAILURE!!', err);
            });
        }, 
        
        // 캔버스 이미지 전송위한 Blob 함수(Blob function for canvas image transfer)
        dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            let byteString
            if (dataURI.split(',')[0].indexOf('base64') >= 0){
                byteString = atob(dataURI.split(',')[1])
            }else {
                byteString = unescape(dataURI.split(',')[1])
            }

            // separate out the mime component
            let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            let ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {type:mimeString});
        }
    }
}
</script>